<div class="row">
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Número de Colaborador:" [value]="workInformation.employeeNumber" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Fecha De Antigüedad:" value="{{ employeeSeniority | dateFormatPipe }}" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Código de Contrato:" [value]="workInformation.contract.contractID" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Description de Contrato:" [value]="workInformation.contract.description" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  </div>
  
  <div class="row">
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Tipo de Nomina:" [value]="workInformation.wage.wageName" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    <div class="col-md-8">
      <mat-form-field class="col-sm-12">
        <input matInput [placeholder]="wageInfo" value="{{ totalAmountPaid | currency:'MXN':'symbol-narrow':'0.2-2' }}"
          type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  </div>
  
  <div class="row">
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Indicador Tipo De Salario:" [value]="workInformation.wage.wageID" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    <div class="col-md-8">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Nombre Tipo de Salario:" [value]="workInformation.wage.payrollType" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  </div>
  
  <div class="row">
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Identificador Unidad Regional:" [value]="workInformation.region.regionID" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    <div class="col-md-8">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Nombre Unidad Regional:" [value]="workInformation.region.regionName" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  </div>
  
  <div class="row">
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Indicador Centro de Trabajo:" [value]="workInformation.workCenter.workCenterID" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    <div class="col-md-8">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Nombre Centro de Trabajo:" [value]="workInformation.workCenter.workCenterName" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  </div>
  
  <div class="row">
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Indicador Empresa:" [value]="workInformation.companyRef.companyID" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    <div class="col-md-8">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Documento Legal Empresa:" [value]="workInformation.companyRef.taxationIdentificationNumber"
          type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  </div>
  
  <div class="row">
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Indicador Del Departamento:" [value]="workInformation.department.departmentID" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    <div class="col-md-8">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Nombre del Departamento:" [value]="workInformation.department.departmentName" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  </div>